import React from 'react';
import { useRenditions } from '@yme/common/hooks';
import { StaticImageStyled, StaticImageWrapperStyled } from './styled';
export function View360StaticImage({ src, altText }) {
    const { imageSrcWithDimension } = useRenditions({
        imageSrc: src,
    });
    return (React.createElement(StaticImageWrapperStyled, null,
        React.createElement(StaticImageStyled, { src: imageSrcWithDimension, alt: altText })));
}
